import { createSlice } from '@reduxjs/toolkit';

const loadingInitialState = {
    isLoading: false,
};

const loadingSlice = createSlice({
    name: 'loading',
    initialState: loadingInitialState,
    reducers: {
        startLoading: (state) => {
            state.isLoading = true;
        },
        stopLoading: (state) => {
            state.isLoading = false;
        },
    },
});

export const { startLoading, stopLoading } = loadingSlice.actions;
export default loadingSlice.reducer;